import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonFr from "./locales/fr/common.json";
import eventFr from "./locales/fr/event.json";
import teacherFr from "./locales/fr/teacher.json";

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      common: commonFr,
      event: eventFr,
      teacher: teacherFr,
    },
  },
  lng: "fr", // Default language
  fallbackLng: "fr", // Language fallback
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
